module.exports = __webpack_public_path__ + "img/svg/background-generic.1804abcdab098a25b1323f6c45090850.svg";